export default __webpack_public_path__ + "static/media/Rectangle 5304.5a2f7f79.png";